import { render, staticRenderFns } from "./ModalSuporteEquipamento.vue?vue&type=template&id=3fb0524b&scoped=true"
import script from "./ModalSuporteEquipamento.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteEquipamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteEquipamento.vue?vue&type=style&index=0&id=3fb0524b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb0524b",
  null
  
)

export default component.exports